module.exports = __webpack_public_path__ + "static/img/shengxian.021fa332.png";